import { Component, Input, Output, EventEmitter } from '@angular/core';
import { HttpService } from '../../../../services/dataAccess.service';
import { CoreService } from '../../../../services/core.service';
import { PropertyData, HtmlBase, CustomgridModel, CustomgridXml, CustomgridSQL, QueovalBase, CustomgridParam, CustomgridColumnDefs, BObjectModel, PropertyGroup, QueovalItem, BObjectSummary, QueovalDik } from '../../../../models';
import { BaseAddOnComponent } from '../base-addon.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { b64UrlEncodeUnicode } from '../../../../utilities';
import { GridApi } from 'ag-grid-community';
import { DomSanitizer } from '@angular/platform-browser';

export class SearchAgGrid extends QueovalBase {
  public columnDefs: any[];
  public rowData: any[];
  public boList: Array<QueovalItem>;
  public reattachedName: string;
  public CodeRelation: string;
  public IdBo: string;
  public IdDonnee: string;
  public Origin: string;
  public Code: string;
  public Where: string;
  public GridName: string;
  public Idents: Array<string>;
}

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-search-ag-grid',
  templateUrl: './search-ag-grid.component.html',
  styleUrls: ['./search-ag-grid.component.css', '../../dynamictag.component.css']
})

export class SearchAgGridComponent extends BaseAddOnComponent {

  // #region DIRECTIVES
  // tslint:disable-next-line:no-input-rename
  @Input('input') input: PropertyData;
  @Input('codeBo') codeBo: string;
  @Input('model') set SetModel(value: BObjectModel) { this.model = value; }


  @Output() navig: EventEmitter<HtmlBase> = new EventEmitter<HtmlBase>(true);
  public customgridParam: CustomgridModel;
  private gridApi: GridApi;
  private filter: string;
  private idProp: string;

  private model: BObjectModel;

  // #region CONSTRUCTEUR
  constructor(
    private http: HttpService,
    private indParam: CoreService,
    private modalService: NgbModal,
    public sanitizer: DomSanitizer
  ) { super(); }
  // #endregion

  // #endregion

  // action associated to the zoom/inputWithButton/selectWithButton elements
  public OnButtonClick(element: HtmlBase, pInput: HtmlBase, pContent: any): void {
    if (element.TypeModal)
      switch (element.TypeModal.toUpperCase()) {
        case 'SEARCHAGGRID':
          if (pInput) {
            this.openModal(pInput.ID, pInput.Value, pContent)
          }
          break;
        default:
          this.navig.emit(element);
          break;
      }
  }
  public openModal(pIdProp: string, filter: string, content: any): void {
    this.indParam.showSplash(true);
    this.filter = filter;
    this.idProp = pIdProp;
    const value: string = b64UrlEncodeUnicode(`${this.codeBo}|${this.input.QueovalCode}|${pIdProp}`);
    this.http.getHttp<SearchAgGrid>(`${this.indParam.AppParams.apiUrl}api/SearchAgGrid/GET_GRID/${value}`).subscribe((result: SearchAgGrid) => {
      if (result) {
        if (result.columnDefs) {

          const index: number = result.columnDefs.findIndex((col) => col.field === "Checked");
          if (index > -1) {
            result.columnDefs[index] =
            {
              field: "Checked",
              filter: false,
              headerName: " ",
              resizable: false,
              sortable: false,
              cellRenderer: function () {
                const eDiv = document.createElement('div');
                eDiv.innerHTML = `<i id="ARROW-LEFT" class="fas fa-arrow-left q-c-main"></i>`;
                return eDiv;
              },
              //pinned: 'left',
              width: 40
            };
          }
        }
      }
      this.customgridParam = new CustomgridModel();
      this.customgridParam.GridXml = new CustomgridXml();
      this.customgridParam.GridXml.rowData = new CustomgridSQL();
      this.customgridParam.cgParameters = new CustomgridParam();
      this.customgridParam.cgParameters.FileName = `${this.input.QueovalCode.toUpperCase()}_${this.input.MainElementList[0].ID}`;
      this.customgridParam.GridXml.columnDefs = result.columnDefs;
      this.customgridParam.GridXml.rowData.data = JSON.stringify(result.rowData);
      this.customgridParam.GridXml.rowSelection = 'single';
      this.customgridParam.cgParameters.isDataLoaded = true;


      this.modalService.open(content, { size: 'xl', centered: true, windowClass: 'modal-ag-grid' }).result.then((modalResult) => {
        switch (modalResult) {
          //  case 'SAVE': this.saveConfigSignature(); break;
          //  case 'CANCEL': this.closeConfigSignature(); break;
        }
      });
      this.indParam.showSplash(false);
    });
  }

  public onGridReady(agGrid: GridApi) {
    this.gridApi = agGrid;
    if (this.filter && this.idProp) {
      const instance = this.gridApi.getFilterInstance(this.idProp);
      if (instance) {
        instance.setModel({ values: [this.filter] });
        this.gridApi.onFilterChanged();
      }
    }
  }
  public OnSelectionChanged(agGrid: GridApi, modalAgGrid: any): void {
    this.gridApi = agGrid;
    const selectedRows = this.gridApi.getSelectedRows();
    
    if (this.model && this.gridApi.getFocusedCell()?.column.getColId() === 'Checked' && selectedRows.length === 1) {
      const keys = Object.keys(selectedRows[0]);
      const iChecked = keys.findIndex((k) => k == 'Checked');
      if (iChecked > -1) {
        keys.splice(iChecked, 1);
      }
      keys.forEach((key: string) => {
        const summary: BObjectSummary[] = this.model.summary.filter((el: BObjectSummary) => {
         return el.ColumnName == key
        });
        if (summary && summary.length == 1) {
          const prop: PropertyData = this.model.Body.SelectedGroupsList[summary[0].IndexGroupsList].DataList[summary[0].IndexDataList];
          prop.MainElementList[0].Value = selectedRows[0][key];
          if (prop && prop.MainElementList[0].SelectOptionsList && prop.MainElementList[0].SelectOptionsList.length > 0) {
            prop.MainElementList[0].SelectOptionsList.forEach((option: QueovalItem) => {
              if (option.Value == prop.MainElementList[0].Value) {
                option.Selected = true;
              } else {
                option.Selected = false;
              }
            })
          }
        }
      });
      modalAgGrid.close('SAVE');
    }
  }

  public getId(item: PropertyData): string {
    return item.MainElementList && item.MainElementList.length > 0 ? item.MainElementList[0].ID : '';
  }

  public setClass(item: PropertyData, index: number = 0): string {
    if (item.MainElementList[index].Required) {
      //alert(item.MainElementList[index].InValid);
      const t: boolean | undefined = item.MainElementList[index].InValid;
    }
    if (item.MainElementList[index].Disabled)
      return 'q-bo-disabled';
    if (item.MainElementList[index].InValid)
      return 'q-bo-novalid';
    if (item.MainElementList[index].Required)
      return 'q-bo-required';
    return '';
  }
  public isDisabled(item: PropertyData): boolean {
    //////return (this.view && this.view === 'read') ? true : item.MainElementList[0].Disabled;
    return item.MainElementList[0].Disabled;
  }
}
